export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
            关于吃瓜网51
          </h2>
          <div className="bg-background-50 rounded-2xl p-8 md:p-10">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-accent-100">
              <i className="ri-global-line text-2xl text-accent-600"></i>
            </div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
              吃瓜网51诞生于广大吃瓜群众对真实、快速娱乐资讯的渴求。作为官方认证的一站式娱乐资讯聚合平台，我们汇聚全网最新鲜的明星八卦、影视动态、综艺热点与社会趣闻。平台采用先进的实时追踪技术，配合专业编辑团队的多重筛选机制，确保每一条资讯都经过严格把关。无论您是通过网页版、正式版还是移动端访问，吃瓜网51始终为您提供安全、稳定、畅快的吃瓜体验，让您不错过每一个值得关注的精彩瞬间。
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-6 text-xs md:text-sm text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-shield-check-line text-accent-500"></i>
                官方认证平台
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-timer-flash-line text-accent-500"></i>
                实时更新追踪
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-user-heart-line text-accent-500"></i>
                百万吃瓜群众信赖
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}